var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.625 6.3v6.75c0 1.491 1.12 2.7 2.5 2.7h3.75c1.38 0 2.5-1.209 2.5-2.7V6.3M10.25 8.325v4.05m-2.5-4.05v4.05m3.75-8.1-.879-1.424a1.228 1.228 0 0 0-1.04-.601H8.419c-.418 0-.808.226-1.04.601L6.5 4.275m5 0h-5m5 0h3.125m-8.125 0H3.375",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgTrash;